/* global charmDefault */
class Personalizer extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    // write element functionality in here
    this.setData();
    this.getElement();
    this.addEventModal();
    this.initSwiper();
    this.addEventStep();
    this.addEventButton();
    this.validateButton();
    this.addEventAtc();
    this.addEventOffer();
  }

  setData() {
    this.hideChain = this.getAttribute("data-hide-chain");
    this.hideExtra = this.getAttribute("data-hide-extra");
    this.hideFavorite = this.getAttribute("data-hide-favorite");
    this.hideFinal = this.getAttribute("data-hide-final");
    this.hideReOrder = this.getAttribute("data-hide-re-order");
    this.useInline = this.getAttribute("data-use-inline") === "true";

    this.config = {
      selectedClass: "selected",
      showClass: "show",
    };

    const dataSteps = this.useInline
      ? ['color', 'chain', 'letter', 'preview', 'favorite', 'extra', 'final']
      : ['color', 'chain', 'name', 'order-number', 'favorite', 'extra', 'final'];
    if (this.hideChain === "true") {
      dataSteps.splice(dataSteps.indexOf('chain'), 1);
    }
    if (this.hideReOrder === "true" && dataSteps.indexOf('order-number') !== -1) {
      dataSteps.splice(dataSteps.indexOf('order-number'), 1);
    }
    if (this.hideFavorite === "true") {
      dataSteps.splice(dataSteps.indexOf('favorite'), 1);
    }
    if (this.hideExtra === "true") {
      dataSteps.splice(dataSteps.indexOf('extra'), 1);
    }

    this.steps = dataSteps.reduce((acc, step, index) => {
      acc[step] = index;
      return acc;
    }, {});

    this.currentStep = "color";
    this.properties = {
      color: "",
      chain: "",
      name: "",
      cord: "",
      charm: "",
    };
    this.cordCharmStage = "cord";
    this.orderNumberValue = "";
    this.breedCharm = {};
    this.favoriteName = {
      v1: "Version 1",
      v2: "Version 2",
      v3: "Version 3",
      v4: "Custom",
    };

    this.productHandle = this.getAttribute("data-product-handle");
    this.productHandleModal = this.getAttribute("data-product");
    this.extraVariant = ""
    this.letterValues = [];
  }

  getElement() {
    this.buttonCustomize = document.querySelector(".js-button-customize");
    this.innerEl = this.querySelector(".js-personalizer-inner");
    this.breedImageEls = this.querySelectorAll(".js-breed-image");
    this.variantId = this.querySelector(".js-variant-id");
    this.priceEls = this.querySelectorAll(".js-price");
    this.priceCompare = this.querySelector(".js-price-compare");
    this.buttonClose = this.querySelector(".js-button-close");
    this.overlay = this.querySelector(".js-overlay");
    this.removes = this.querySelectorAll(".js-remove");
    this.resultColor = this.querySelector(".js-result-color");
    this.resultChain = this.querySelector(".js-result-chain");
    this.resultBreed = this.querySelector(".js-result-breed");
    this.resultHalo = this.querySelector(".js-result-halo");
    // this.message = this.querySelector('.js-message')
    this.buttonAtcs = this.querySelectorAll(".js-button-atc");
    this.buttonOfferEls = this.querySelectorAll(".js-button-offer");

    this.favoriteEl = this.querySelector(".js-personalizer-favorite");
    this.favoriteSampleEl = this.querySelector(".js-personalizer-favorite-sample");
    this.favoriteContentEl = this.querySelector(
      ".js-personalizer-favorite-content"
    );
    this.favoriteEmptyEl = this.querySelector(
      ".js-personalizer-favorite-empty"
    );
    this.resultFavorite = this.querySelector(".js-result-favorite");
    this.stepFavorite = this.querySelector(".js-step-favorite");
    this.buttonPriceEl = this.querySelector(".js-button-price");
    this.extraMeaningInputs = this.querySelectorAll('.js-extra-meaning');
    this.extraProductEls = this.querySelectorAll('extra-product');
    this.cordCharmStepEl = this.querySelector("personalizer-color-cord-charm-step");
    this.cordCharmStage = "cord";
  }

  getExtraItems() {
    this.extraItems = [];
    const extraItemsEls = this.querySelectorAll(`new-extra-stone.js-validation .js-extra-item.${CONFIG.selectedClass}`);

    extraItemsEls.forEach((extraItem) => {
      const variantId = extraItem.dataset.variant;
      const dataKey = extraItem.dataset.key;
      const dataValue = extraItem.dataset.value;
      const properties = {
        [dataKey]: dataValue,
      }

      const itemCart = {
        id: variantId,
        properties: {},
        quantity: 1,
      }
      this.extraItems = [
        ...this.extraItems,
        itemCart,
      ]

      this.properties = {
        ...this.properties,
        ...properties,
      }
    });
  }

  addEventAtc() {
    this.buttonAtcs.forEach((buttonAtc) => {
      buttonAtc.addEventListener("click", async () => {
        // No validation required for upsell selection
        // Collect selected upsells
        const selectedMeanings = Array.from(this.extraMeaningInputs || []).filter(input => input instanceof HTMLInputElement && input.checked);
        let extraItems = [];
        let propertiesBirthstone = {};
        let propertiesScratch = {
              'scratch card': 'no',
            }
        let totalUpsellPrice = 0;
        const now = new Date().getTime();

        selectedMeanings.forEach(selectedMeaning => {
          if (selectedMeaning.value === 'birthstone') {
            let charmIndex = 1;
            extraItems = [
              ...extraItems,
              ...Array.from(this.extraProductEls || [])
                .filter(product => product.classList.contains('active'))
                .map(product => {
                  let variantId = product.getAttribute('data-variant-id');
                  if (!variantId) {
                    const variantEl = product.querySelector('[data-variant-id]');
                    if (variantEl) variantId = variantEl.getAttribute('data-variant-id');
                  }
                  const qtyInput = product.querySelector('.js-qty-input');
                  const quantity = qtyInput && qtyInput instanceof HTMLInputElement ? parseInt(qtyInput.value, 10) || 1 : 1;
                  const birthstoneName = product.querySelector('.js-birthstone-name');
                  const birthstoneNameValue = birthstoneName && birthstoneName instanceof HTMLInputElement ? birthstoneName.value : '';
                  if (quantity > 0) {
                    for (let i = 0; i < quantity; i++) {
                      propertiesBirthstone = {
                        ...propertiesBirthstone,
                        [`Extra charm ${charmIndex}`]: birthstoneNameValue,
                        _created_at: now,
                      }
                      charmIndex++;
                    }
                  }
                  // Add price for each selected birthstone
                  const price = product.querySelector('.js-price');
                  let priceValue = 0;
                  if (price && price instanceof HTMLElement && price.dataset && typeof price.dataset.price === 'string') {
                    priceValue = parseInt(price.dataset.price, 10) || 0;
                  }
                  totalUpsellPrice += priceValue * quantity;
                  return {
                    id: variantId,
                    quantity,
                    properties: { _parent: this.productHandle, _created_at: now }
                  };
                })
            ];
          } else if (selectedMeaning.value === 'scratch-reveal-card') {
            let variantId = '';
            let priceValue = 0;
            if (selectedMeaning instanceof HTMLInputElement) {
              variantId = selectedMeaning.dataset && selectedMeaning.dataset.variantId ? selectedMeaning.dataset.variantId : '';
              priceValue = selectedMeaning.dataset && selectedMeaning.dataset.price ? parseInt(selectedMeaning.dataset.price, 10) || 0 : 0;
            }
            extraItems.push({
              id: variantId,
              quantity: 1,
              properties: {
                name: this.properties.name,
                _card: this.productHandle,
                _created_at: now,
              }
            });
            totalUpsellPrice += priceValue;
            propertiesScratch = {
              'scratch card': 'yes',
            }
          } else if (
            selectedMeaning.value === 'lifetime-warranty' ||
            selectedMeaning.value === 'gift-box'
          ) {
            let variantId = '';
            let priceValue = 0;
            if (selectedMeaning instanceof HTMLInputElement) {
              variantId =
                selectedMeaning.dataset && selectedMeaning.dataset.variantId
                  ? selectedMeaning.dataset.variantId
                  : '';
              priceValue =
                selectedMeaning.dataset && selectedMeaning.dataset.price
                  ? parseInt(selectedMeaning.dataset.price, 10) || 0
                  : 0;
            }
            if (variantId) {
              extraItems.push({
                id: variantId,
                quantity: 1,
                properties: {
                  _card: this.productHandle,
                  _created_at: now,
                },
              });
              totalUpsellPrice += priceValue;
            }
          }
        });

        // Always add the main product
        let variantId = '';
        if (this.variantId && this.variantId instanceof HTMLInputElement) {
          variantId = this.variantId.value;
        }
        if (this.extraVariant) {
          variantId = this.extraVariant;
        }

        // Safety net: whatever the step machine did, the cord/charm the shopper
        // sees selected are the ones that go on the order.
        if (this.cordCharmStepEl) {
          if (!this.properties.cord && this.cordCharmStepEl.selectedCord) this.properties.cord = this.cordCharmStepEl.selectedCord.label || "";
          if (!this.properties.charm && this.cordCharmStepEl.selectedCharm) this.properties.charm = this.cordCharmStepEl.selectedCharm.label || "";
          // A cord bracelet must never reach the cart without both: send the
          // shopper back to that step instead of adding a half-blank line.
          if (!this.properties.cord || !this.properties.charm) {
            if (typeof this.cordCharmStepEl.reset === "function") this.cordCharmStepEl.reset();
            this.currentStep = "color";
            this.goToStep("color");
            return;
          }
        }

        // The reference stays inside "name" as production reads it today, and is
        // also written on its own so it can be read as a field, not parsed.
        this.properties = Object.fromEntries(
          Object.entries({
            ...this.properties,
            name: [this.properties.name, this.orderNumberValue].filter(Boolean).join(', '),
            'Previous order': this.orderNumberValue,
          }).filter(([, value]) => !!value)
        );

        const items = [
          ...extraItems,
          {
            id: variantId,
            properties: {
              ...this.properties,
              ...propertiesBirthstone,
              ...propertiesScratch,
              _created_at: now,
            },
            quantity: 1,
          }
        ];

        const data = {
          'items': items
        };

        const buttonTextEl = buttonAtc.querySelector(".js-button-text");
        const buttonText = buttonTextEl ? buttonTextEl.textContent : '';
        if (buttonAtc instanceof HTMLButtonElement) buttonAtc.disabled = true;
        if (buttonTextEl) buttonTextEl.textContent = "Adding...";
        const url = buttonAtc.dataset.url;
        const handle = buttonAtc.dataset.handle;
        const nextStep = buttonAtc.dataset.nextStep;

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then(async (data) => {
            if (buttonTextEl) buttonTextEl.textContent = "Added to cart";
            if (buttonAtc instanceof HTMLButtonElement) buttonAtc.disabled = false;

            // // fetch data cart
            // const cartData = await fetch("/cart.js", {
            //     method: "GET",
            //     headers: {
            //       "Content-Type": "application/json",
            //     }
            //   })
            // const cartDataJson = await cartData.json()
            // let showOffer = true
            // let mainItem = 0
            // cartDataJson.items.forEach(item => {
            //   if (!item?.properties?._parent && !item?.properties?._card) {
            //     mainItem++
            //   }
            // });
            // if (mainItem % 2 === 0) {
            //   showOffer = false
            // }
            let showOffer = true

            if (this.hideFinal === "true") {
              showOffer = false
            }

            // fetch data cart
            const cartData = await fetch("/cart.js", {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                }
              })
            const cartDataJson = await cartData.json()
            let mainItem = 0
            cartDataJson.items.forEach(item => {
              if (!item?.properties?._parent && !item?.properties?._card) {
                mainItem = mainItem + item.quantity;
              }
            });

            setTimeout(() => {
              if ((!handle && !nextStep) || !showOffer) {
                window.location.href = '/cart';
              } else {
                if (nextStep === "final") {
                  this.dispatchEvent(new CustomEvent("update-progress", {
                    detail: {
                      step: mainItem,
                    },
                  }));
                  this.goToStep("final");
                } else {
                  this.closeModal();
                  this.resetAll();
                  this.openModal(handle);
                }
              }
              if (buttonTextEl) buttonTextEl.textContent = buttonText;
            }, 500);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
    });
  }

  addEventOffer() {
    if (this.buttonOfferEls?.length === 0) {
      return;
    }

    this.buttonOfferEls?.forEach((buttonOffer) => {
      buttonOffer.addEventListener("click", () => {
        const template = buttonOffer.dataset.template;
        const url = buttonOffer.dataset.url;
        const handle = buttonOffer.dataset.handle;

        // Inline-template products keep their own page customizer: go there.
        // Everything else opens the in-page instance rendered for the offer.
        if (template.indexOf('personalizer-inline') !== -1) {
          window.location.href = url;
          return;
        }
        const modal = document.querySelector(
          `.js-personalizer[data-product="${handle}"]`
        );
        if (modal) {
          this.closeModal();
          this.resetAll();
          this.openModal(handle, url);
        } else if (url) {
          window.location.href = url;
        }
      });
    });
  }

  closeModal() {
    this.classList.remove("open");
  }

  resetAll() {
    this.properties = {
      color: "",
      chain: "",
      name: "",
      cord: "",
    };
    this.orderNumberValue = "";
    this.currentStep = "color";
    this.resetStep("color");
    if (this.hideChain !== "true") {
      this.resetStep("chain");
    }
    if (this.hideExtra !== "true") {
      this.resetStep("extra");
    }
    this.resetStep("name");
    this.goToStep("color");
    this.validateButton();
  }

  openModal(handle, url = null) {
    const modal = document.querySelector(
      `.js-personalizer[data-product="${handle}"]`
    );
    if (modal) {
      this.classList.remove("open");
      modal.classList.add("open");
      if (typeof modal.emitStep === "function") modal.emitStep(modal.currentStep);
    }

    if (!modal && url) {
      window.location.href = url;
    }
  }

  addEventModal() {
    this.buttonCustomize.addEventListener("click", (e) => {
      e.preventDefault();
      const _productHandle = this.buttonCustomize.dataset.handle;
      if (this.productHandleModal !== _productHandle) {
        return;
      }
      this.classList.add("open");
      this.emitStep(this.currentStep);
    });
    this.buttonClose.addEventListener("click", () => {
      this.closeModal();
    });
    this.overlay.addEventListener("click", () => {
      this.closeModal();
    });
  }

  initSwiper() {
    this.swiperEl = this.querySelector("swiper-container");
  }

  renderFavoriteStep() {
    this.properties.favorite = ''
    const button = this.querySelector(
      'button[data-step="favorite"]'
    );

    if (button) {
      button.dataset.type = 'next-guide'
    }


    const name = this.properties.name.toLocaleLowerCase();
    let favorite = null;
    if (typeof favoriteDesign !== undefined) {
      favorite = favoriteDesign.find(
        (x) => x.name.trim() === name.trim()
      );
    }
    this.favoriteItem = favorite;
    const onlyEmpty = this.favoriteEmptyEl.dataset.only === "true";

    if (onlyEmpty) {
      button.dataset.type = 'next-step'
    }

    if (favorite && 1 !== 1) {
      this.favoriteContentEl.innerHTML = "";
      const items = [favorite.v1, favorite.v2, favorite.v3];
      items.forEach((item, index) => {
        const itemEl = `
          <div class="personalizer__favorite-item">
            <div class="personalizer__favorite-inner js-favorite-item" data-name="v${index + 1}">
              <img src="${item}" alt="${favorite.name}" class="personalizer__favorite-image">
              <span>${this.favoriteName[`v${index + 1}`]}</span>
            </div>
          </div>
        `;
        this.favoriteContentEl.insertAdjacentHTML("beforeend", itemEl);
      });
      this.favoriteContentEl.insertAdjacentHTML(
        "beforeend",
        `
          <div class="personalizer__favorite-item personalizer__favorite-item-custom">
            <div class="personalizer__favorite-inner js-favorite-item" data-name="v4">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" fill="none">
                <path fill="url(#a)" d="M0 0h30v30H0z"/>
                <defs>
                  <pattern id="a" width="1" height="1" patternContentUnits="objectBoundingBox">
                    <use xlink:href="#b" transform="scale(.005)"/>
                  </pattern>
                  <image xlink:href="data:image/png;base64,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" id="b" width="200" height="200"/>
                </defs>
              </svg>
              <div>
                Designed from scratch
                <p>Get your custom preview within 24-48 hours of purchase</p>
              </div>
              <span>${this.favoriteName["v4"]}</span>
            </div>
          </div>
        `
      );

      const itemEls =
        this.favoriteContentEl.querySelectorAll(".js-favorite-item");
      itemEls.forEach((itemEl) => {
        itemEl.addEventListener("click", () => {
          itemEls.forEach((x) =>
            x.classList.remove(this.config?.selectedClass)
          );
          itemEl.classList.add(this.config?.selectedClass);
          this.properties.favorite = this.favoriteName[itemEl.dataset.name];
          // this.resultFavorite.textContent =
          //   this.favoriteName[itemEl.dataset.name];

          // if (itemEl.dataset.name === "v4") {
          //   button.dataset.type = "next-guide";
          // } else {
          //   button.dataset.type = "";
          // }

          this.validateButton();
        });
      });

      this.favoriteEmptyEl.style.display = "none";
      this.favoriteSampleEl.style.display = "none";
      this.favoriteEl.style.display = "block";
      button.dataset.type = "";
    } else {
      this.showSampleFavorite()
    }

    if (onlyEmpty) {
      this.favoriteSampleEl.style.display = "none";
      this.favoriteEl.style.display = "none";
      this.favoriteEmptyEl.style.display = "block";
      this.favoriteItem = null;
      this.properties.favorite = "";
      this.classList.add('is-favorite-empty');
    }
  }

  showSampleFavorite () {
    this.favoriteEl.style.display = "none";
    this.favoriteEmptyEl.style.display = "none";

    // Uncheck all favorite checkboxes and remove selected class from all favorite options
    const favoriteOptions = this.querySelectorAll(".js-favorite-option");
    favoriteOptions.forEach((option) => {
      option.classList.remove('personalizer-favorite__option--selected');
    });
    const favoriteCheckboxes = this.querySelectorAll(".js-favorite-checkbox");
    favoriteCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    this.favoriteSampleEl.style.display = "block";
  }

  showFavoriteGuide(buttonEl) {
    if (this.properties.favorite === "Custom") {
      this.showSampleFavorite()
      return
    }

    this.favoriteSampleEl.style.display = "none";
    this.favoriteEl.style.display = "none";
    this.favoriteEmptyEl.style.display = "block";
    this.classList.add('is-favorite-empty');

    buttonEl.dataset.type = "next-step";
  }

  /* Step reached: same `cfg:step` event the classic and chat customizers emit,
     consumed by the A/B tracking layer (ab-customizer.js) so the live arm has
     the same funnel. Offer instances (data-product ends with -offer-N) are
     reported separately. */
  emitStep(step) {
    if (!step) return;
    const scope = (this.productHandleModal || "").indexOf("-offer-") > -1 ? "live:offer:" : "live:";
    try {
      this.dispatchEvent(
        new CustomEvent("cfg:step", {
          bubbles: true,
          detail: { step: scope + step, engine: "custom-personalizer" },
        })
      );
    } catch (err) {
      /* ignore */
    }
  }

  goToStep(step) {
    if (step === "favorite") {
      this.renderFavoriteStep();
    }

    this.currentStep = step;
    this.emitStep(step);

    const stepIndex = this.steps[step];
    this.swiperEl.swiper.slideTo(stepIndex);
    this.validateButton();

    Object.keys(this.steps).forEach((key) => {
      this.classList.remove(key);
    });
    this.classList.add(this.currentStep);

    const scrollEl = this.querySelector(".personalizer__inner");
    if (scrollEl) scrollEl.scrollTo({ top: 0 });
  }

  addEventButton() {
    const buttons = this.querySelectorAll(".js-button");
    buttons?.forEach((button) => {
      button.addEventListener("click", () => {
        const step = button.dataset.nextStep;
        const type = button.dataset.type;
        if (type === "next-guide") {
          this.showFavoriteGuide(button);
        } else {
          this.goToStep(step);
        }
      });
    });
  }

  stepColor() {
    this.selectedColorEl = this.querySelector(".js-color-selected");
    this.colorMessageEl = this.querySelector('.js-color-message')
    this.colors = this.querySelectorAll(".js-color-item");
    this.colors?.forEach((color) => {
      color.addEventListener("click", () => {
        this.properties.color = color.dataset.color;
        this.resetStep("color");
        color.classList.add(this.config.selectedClass);
        this.selectedColorEl.textContent = color.dataset.color;
        // this.resultColor.textContent = color.dataset.color;
        this.validateButton();
        this.changeBreedImage();

        if (this.colorMessageEl) {
          this.colorMessageEl.setAttribute('data-color', color.dataset.color)
        }
      });
    });
  }

  stepCordCharm() {
    if (!this.cordCharmStepEl) return;

    this.addEventListener("cordCharmStepUpdated", (event) => {
      if (!(event instanceof CustomEvent)) return;
      if (!event.detail || typeof event.detail !== "object") return;

      const {
        stage = "cord",
        cord = "",
        charm = "",
      } = event.detail;

      this.cordCharmStage = stage;
      this.properties.cord = cord;
      this.properties.charm = charm;

      this.validateButton();
    });
  }

  stepChain() {
    this.selectedChainEl = this.querySelector(".js-chain-selected");
    this.chainImageEl = this.querySelector(".js-chain-image");
    this.chains = this.querySelectorAll(".js-chain-item");
    this.chains?.forEach((chain) => {
      chain.addEventListener("click", () => {
        this.properties.chain = chain.dataset.chain;
        this.resetStep("chain");
        chain.classList.add(this.config.selectedClass);
        this.selectedChainEl.textContent = chain.dataset.chain;
        this.chainImageEl.src = chain.dataset.image;
        // this.resultChain.textContent = chain.dataset.chain;
        this.validateButton();
      });
    });
  }

  changeBreedImage() {
    const breedImage = this.breedCharm[this.properties.color] || charmDefault;
    if (breedImage) {
      this.breedImageEls.forEach((el) => (el.src = breedImage));
    }
  }

  addEventButtonName() {
    this.properties.charm = "to design";
    // this.resultBreed.textContent = "to design";
    this.breedCharm = {};
    this.changeBreedImage();
    const buttonName = this.querySelector(".js-button-name");
    buttonName.addEventListener("click", () => {
      this.goToStep("name");
    });
  }

  stepName() {
    this.nameEl = this.querySelector(".js-personalizer-name");
    if (!this.nameEl) return;
    // this.resultNameEl = this.querySelector(".js-result-name");
    this.nameEl.addEventListener("input", (e) => {
      this.properties.name = e.target.value;
      // this.resultNameEl.textContent = e.target.value;
      // this.message.classList.add(this.config.showClass)
      this.validateButton();
    });
  }

  stepOrderNumber() {
    const orderNumberEl = this.querySelector(".js-personalizer-order-number");
    if (!orderNumberEl) return;
    orderNumberEl.addEventListener("input", (e) => {
      this.orderNumberValue = e.target.value.trim();
      this.validateButton();
    });
  }

  stepHalo() {
    this.variantEls = this.querySelectorAll(".js-variant-item");
    this.variantEls?.forEach((variant) => {
      variant.addEventListener("click", () => {
        this.properties.halo = variant.dataset.variantTitle;
        // this.resultHalo.textContent = variant.dataset.variantTitle;
        this.variantId.value = variant.dataset.variantId;
        this.priceEls.forEach(
          (price) => (price.textContent = variant.dataset.variantPrice)
        );
        this.priceCompare.textContent = variant.dataset.variantPriceCompare;
        this.variantEls.forEach((x) =>
          x.classList.remove(this.config.selectedClass)
        );
        variant.classList.add(this.config.selectedClass);
        this.validateButton();
      });
    });
  }

  resetStep(step) {
    switch (step) {
      case "color":
        this.properties.cord = "";
        this.properties.charm = "";
        if (this.cordCharmStepEl && typeof this.cordCharmStepEl.reset === "function") this.cordCharmStepEl.reset();
        this.colors?.forEach((x) =>
          x.classList.remove(this.config.selectedClass)
        );
        if (this.selectedColorEl) {
          this.selectedColorEl.textContent = "";
        }
        this.changeBreedImage();
        break;
      case "chain":
        this.chains?.forEach((x) =>
          x.classList.remove(this.config.selectedClass)
        );
        if (this.selectedChainEl) this.selectedChainEl.textContent = "";
        if (this.chainImageEl) this.chainImageEl.src = this.chainImageEl.dataset.default;
        break;
      case "name":
        // Letter-flow products have no name input: a null here used to throw and
        // abort "customize another" (the offer modal never opened).
        if (this.nameEl) this.nameEl.value = "";
        // this.resultNameEl.textContent = "";
        this.properties.name = "";
        this.properties.Preview = "";
        this.letterEls?.forEach((el) => { el.selectedIndex = 0; });
        this.querySelectorAll('[name^="preview-option"]').forEach((r) => { r.checked = false; });
        if (this.previewValueEl) this.previewValueEl.value = "";
        const stepNames = this.querySelectorAll(".js-step-name");
        stepNames.forEach((stepName) => (stepName.style.display = "none"));
        // this.message.classList.remove(this.config.showClass)
        break;
      case "order-number": {
        const orderNumberEl = this.querySelector(".js-personalizer-order-number");
        if (orderNumberEl) {
          orderNumberEl.value = "";
          this.orderNumberValue = "";
        }
        break;
      }
      case "extra":
        this.properties["Extra charm 1"] = "";
        this.properties["Extra charm 2"] = "";
        this.properties["Extra charm 3"] = "";

        // remove checked of this.extraMeaningInputs
        if (this.extraMeaningInputs) {
        this.extraMeaningInputs.forEach(input => {
            input.checked = false;
          });
        }
        if (this.extraProductEls) {
          this.extraProductEls.forEach(product => {
            product.classList.remove('active');
          });
        }
        break;
      case "halo":
        this.priceEls.forEach(
          (price) => (price.textContent = price.dataset.price)
        );
        this.priceCompare.textContent = this.priceCompare.dataset.price;
        this.variantEls.forEach((x) =>
          x.classList.remove(this.config.selectedClass)
        );
        break;
      default:
        break;
    }
  }

  stepFinal() {
    this.removes?.forEach((remove) => {
      remove.addEventListener("click", () => {
        const step = remove.dataset.step;
        this.currentStep = step;
        this.goToStep(step);
        this.resetStep(step);
        this.properties[step] = "";
        this.validateButton();
      });
    });
  }

  stepFavoriteNew() {
    const favoriteOptions = this.querySelectorAll('.js-favorite-option');
    const favoriteCheckboxes = this.querySelectorAll('.js-favorite-checkbox');

    favoriteOptions?.forEach((option) => {
      option.addEventListener('click', (e) => {
        // Don't trigger if clicking on checkbox directly
        if (e.target.closest('.personalizer-favorite__checkbox')) {
          return;
        }

        const checkbox = option.querySelector('.js-favorite-checkbox');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          this.handleFavoriteSelection(checkbox);
        }
      });
    });

    favoriteCheckboxes?.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.handleFavoriteSelection(checkbox);
      });
    });
  }

  handleFavoriteSelection(checkbox) {
    const option = checkbox.closest('.js-favorite-option');
    const style = option?.dataset.style;

    if (checkbox.checked) {
      // Uncheck all other options
      const allCheckboxes = this.querySelectorAll('.js-favorite-checkbox');
      allCheckboxes.forEach(cb => {
        if (cb !== checkbox) {
          cb.checked = false;
          cb.closest('.js-favorite-option')?.classList.remove('personalizer-favorite__option--selected');
        }
      });

      // Select current option
      option?.classList.add('personalizer-favorite__option--selected');
      this.properties.favorite = style;
    } else {
      // Deselect current option
      option?.classList.remove('personalizer-favorite__option--selected');
      this.properties.favorite = "";
    }

    this.validateButton();
  }

  addEventStep() {
    this.stepColor();
    this.stepCordCharm();
    this.stepChain();
    this.stepName();
    this.stepOrderNumber();
    this.stepHalo();
    this.stepFinal();
    this.stepFavoriteNew();
    this.stepLetter();
    this.stepPreview();

    // this.stepExtra();
    // this.stepExtraNew();
    this._bindExtraMeaningEvents();
  }

  stepLetter() {
    this.letterEls = this.querySelectorAll(".js-personalizer-letter");
    if (!this.letterEls.length) return;

    this.letterEls.forEach((el) => {
      this.letterValues[el.dataset.index] = el.value;
    });

    this.letterEls.forEach((el) => {
      el.addEventListener("change", (e) => {
        this.letterValues[e.target.dataset.index] = e.target.value;
        this.renderLetterPreview();
      });
    });

    this.renderLetterPreview();
  }

  renderLetterPreview() {
    this.previewEl = this.querySelector(".js-preview");
    this.previewOptionsEl = this.querySelector(".js-preview-options");
    this.previewValueEl = this.querySelector(".js-preview-value");
    if (!this.previewOptionsEl) return;
    // Previews of this very product (JSON rendered inside the instance); global fallback for older markup.
    if (!this.previewsData) {
      const dataEl = this.querySelector(".js-previews-data");
      try {
        this.previewsData = dataEl ? JSON.parse(dataEl.textContent) : (typeof previews !== "undefined" ? previews : []);
      } catch (err) {
        this.previewsData = [];
      }
    }
    const previewsList = this.previewsData;

    const joined = this.letterValues.join(" + ");
    const letterTitles = [joined.toLocaleLowerCase()];
    if (typeof propertyPreview !== "undefined" && propertyPreview === "Letters") {
      letterTitles.push([...this.letterValues].reverse().join(" + ").toLocaleLowerCase());
    }

    const lettersKey =
      (typeof propertyPreview !== "undefined" && propertyPreview) || "Letters";
    this.properties[lettersKey] = joined;

    this.querySelectorAll(".js-preview-letters").forEach((el) => {
      el.textContent = joined;
    });

    const preview = previewsList.find((item) =>
      letterTitles.includes(item.title.toLocaleLowerCase())
    );

    const imageV1 = this.querySelector(".js-preview-option[data-preview-option='1']");
    const imageV2 = this.querySelector(".js-preview-option[data-preview-option='2']");
    const imageV3 = this.querySelector(".js-preview-option[data-preview-option='3']");

    if (preview && preview.image && preview.image_v2 && preview.image_v3) {
      if (imageV1) imageV1.src = preview.image;
      if (imageV2) imageV2.src = preview.image_v2;
      if (imageV3) imageV3.src = preview.image_v3;
      const checked = this.querySelector('[name^="preview-option"]:checked');
      this.properties.Preview = checked ? checked.value : "";
      if (this.previewValueEl) this.previewValueEl.value = this.properties.Preview;
      this.previewOptionsEl.classList.remove("personalizer-preview-options--single");
    } else if (preview && preview.image) {
      if (imageV1) imageV1.src = preview.image;
      if (imageV2) imageV2.src = "";
      if (imageV3) imageV3.src = "";
      this.properties.Preview = "v1";
      if (this.previewValueEl) this.previewValueEl.value = "v1";
      this.previewOptionsEl.classList.add("personalizer-preview-options--single");
    } else {
      if (imageV1) imageV1.src = "";
      if (imageV2) imageV2.src = "";
      if (imageV3) imageV3.src = "";
      this.properties.Preview = "";
      if (this.previewValueEl) this.previewValueEl.value = "";
    }
  }

  stepPreview() {
    const options = this.querySelectorAll('[name^="preview-option"]');
    if (!options.length) return;
    options.forEach((option) => {
      option.addEventListener("change", () => {
        this.properties.Preview = option.value;
        if (this.previewValueEl) this.previewValueEl.value = option.value;
        this.validateButton();
      });
    });
  }

  _bindExtraMeaningEvents() {
    if (!this.extraMeaningInputs) return;
    this.extraMeaningInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.validateButton();
      });
    });
    if (this.extraProductEls) {
      this.extraProductEls.forEach(product => {
        product.addEventListener('click', () => {
          this.validateButton();
        });
      });
    }
    // Listen for extra product price changes
    this.addEventListener('extraMeaningBirthstonePriceChanged', (e) => {
      if (e instanceof CustomEvent && this.buttonPriceEl) {
        this._calculateTotalPrice();
      }
    });
    this.addEventListener('extraProductPriceChanged', (e) => {
      if (e instanceof CustomEvent && this.buttonPriceEl) {
        this._calculateTotalPrice();
      }
    });
  }

  _calculateTotalPrice() {
    const extraMeaningChecked = Array.from(this.extraMeaningInputs || []).filter(input => input instanceof HTMLInputElement && input.checked);
    const extraMeaningPrice = extraMeaningChecked.reduce((acc, input) => {
      const price = input.dataset && input.dataset.price ? parseInt(input.dataset.price, 10) || 0 : 0;
      return acc + price;
    }, 0);
    let totalPrice = 0;
    extraMeaningChecked.forEach(selectedMeaning => {
      if (selectedMeaning.value === 'birthstone') {
        totalPrice = Array.from(this.extraProductEls || [])
          .filter(product => product.classList.contains('active'))
          .reduce((acc, product) => {
            const qtyInput = product.querySelector('.js-qty-input');
            const quantity = qtyInput && qtyInput instanceof HTMLInputElement ? parseInt(qtyInput.value, 10) || 1 : 1;
            const price = product.querySelector('.js-price');
            let priceValue = 0;
            if (price && price instanceof HTMLElement && price.dataset && typeof price.dataset.price === 'string') {
              priceValue = parseInt(price.dataset.price, 10) || 0;
            }
            return acc + priceValue * quantity;
          }, 0);
      }
    })

    this.getProductPrice(extraMeaningPrice + totalPrice)
  }

  stepExtraNew() {
    this.extraItems = [];

    document.addEventListener("extraSelected", (e) => {
      const price = e.detail.price;
      this.getProductPrice(price);
    });

    // document.addEventListener("updateProperties", (e) => {
    //   const properties = e.detail.properties;
    //   const productHandle = e.detail.productHandle;

    //   if (productHandle && productHandle === this.productHandle) {
    //     this.properties = {
    //       ...this.properties,
    //       ...properties,
    //     }
    //   }
    // });

    // const _this = this;
    // document.addEventListener("updateExtraCartItem", () => {
    //   _this.extraItems = [];
    //   const extraItemsEls = _this.querySelectorAll(`new-extra-stone.js-validation .js-extra-item.${CONFIG.selectedClass}`);
    //   // eslint-disable-next-line no-console
    //   console.log('extraItemsEls', extraItemsEls)


    //   extraItemsEls.forEach((extraItem) => {
    //     const variantId = extraItem.dataset.variant;
    //     const itemCart = {
    //       id: variantId,
    //       properties: {},
    //       quantity: 1,
    //     }
    //     _this.extraItems = [
    //       ..._this.extraItems,
    //       itemCart,
    //     ]
    //   });
    // });
  }

  stepExtra() {
    this.extraPreviewEl = this.querySelector(".js-extra-image");
    this.extraCurrentEl = this.querySelector(".js-extra-current");
    this.extraItemEls = this.querySelectorAll(".js-extra-item");
    this.buttonPriceEl = this.querySelector(".js-button-price");
    this.extraStep = this.querySelector(".js-extra-step");

    // this.extraEvent()
  }

  extraEvent() {
    this.extraCurrentEl?.addEventListener(
      "click",
      this.handleExtraClick.bind(this, true)
    );

    this.extraItemEls?.forEach((el) => {
      el.addEventListener("click", () => {
        this.extraStep.classList.remove("personalizer__step-error");
        this.handleExtraItemClick(el);
      });
    });
  }

  validateExtraNew() {
    const validateEls = this.querySelectorAll(".js-validation");

    if (validateEls.length === 0) {
      return false;
    }

    let hasError = false;
    validateEls.forEach((el) => {
      const selectEl = el.querySelector(".js-select");
      const valueSelected = selectEl.querySelector(".js-select-value").dataset.value;
      if (!valueSelected) {
        hasError = true;
        el.classList.add("custom-select--error");
      } else {
        el.classList.remove("custom-select--error");
      }
    });

    return hasError;
  }

  validateExtra() {
    if (this.currentStep !== "extra") {
      return false;
    }
    if (this.currentStep === "extra" && this.properties["Extra charm"] === "") {
      this.extraStep.classList.add("personalizer__step-error");
      return true;
    }
    this.extraStep.classList.remove("personalizer__step-error");
    return false;
  }

  handleExtraClick(show = true) {
    if (show) {
      this.extraCurrentEl?.nextElementSibling?.classList?.add(
        this.config?.showClass || "show"
      );
    } else {
      this.extraCurrentEl?.nextElementSibling?.classList?.remove(
        this.config?.showClass || "show"
      );
    }
  }

  handleExtraItemClick(item) {
    this.extraItemEls?.forEach((el) => {
      el.classList.remove("active");
    });
    item.classList.add("active");

    this.extraCurrentEl.querySelector("img").src = item.dataset.icon;
    this.extraCurrentEl.querySelector("span").innerText = item.dataset.name;
    this.extraPreviewEl.src = item.dataset.image;
    this.properties["Extra charm"] = item.dataset.value;
    this.handleExtraClick(false);
    this.validateButton();
    this.getProductPrice(item.dataset.price);
    this.extraVariant = item.dataset.variant;
  }

  getProductPrice(extraPrice) {
    if (!this.buttonPriceEl) return;

    const price = parseInt(this.buttonPriceEl.dataset.price) + parseInt(extraPrice);

    this.buttonPriceEl.innerHTML = this.formatMoney(price);
  }

  formatMoney(cents, formatString = Shopify.money_format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      const parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  validateButton() {
    let button = this.querySelector(
      '.js-button[data-step="' + this.currentStep + '"]'
    );

    if (!button) {
      button = this.querySelector(
        '.js-button-atc[data-step="' + this.currentStep + '"]'
      );
    }

    if (!button) {
      return;
    }

    console.log(this.properties, this.currentStep)


    button.disabled = true;
    switch (this.currentStep) {
      case "color":
        if (this.cordCharmStepEl) {
          if (this.cordCharmStage === "charm") {
            button.disabled = this.properties.charm === "";
          } else {
            button.disabled = this.properties.cord === "";
          }
        } else {
          button.disabled = this.properties.color === "";
        }
        break;
      case "chain":
        button.disabled = this.properties.chain === "";
        break;
      case "favorite":
        button.disabled = this.properties.favorite === "" && this.favoriteEmptyEl.dataset.only !== "true";
        break;
      case "extra":
        // Allow continue even if neither upsell is selected
        button.disabled = false;
        break;
      case "name":
        button.disabled = this.properties.name === "";
        const stepNames = this.querySelectorAll(".js-step-name");
        stepNames.forEach((stepName) => (stepName.style.display = "block"));
        break;
      case "order-number":
        button.disabled = this.orderNumberValue === "";
        break;
      case "letter":
        button.disabled = false;
        break;
      case "preview": {
        const isSingle = this.previewOptionsEl?.classList.contains("personalizer-preview-options--single");
        const hasOptions = this.querySelectorAll('[name^="preview-option"]').length > 0;
        button.disabled = hasOptions && !isSingle && !this.querySelector('[name^="preview-option"]:checked');
        break;
      }
      case "halo":
        if (this.properties.halo === "Yes") {
          // this.message.classList.add(this.config.showClass)
        } else {
          // this.message.classList.remove(this.config.showClass)
        }
        button.disabled = this.properties.halo === "";
        break;
      default:
        break;
    }
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
}

customElements.define("custom-personalizer", Personalizer);
